import { useI18n } from 'vue-i18n'

export const translations = {
  'pt-br': {
    Logout: 'Sair',
    MyCompany: 'Minha empresa',
    MyProfile: 'Meu perfil',
    SystemInfo: 'Informações',
    MyPlan: 'Meu plano',
    SelectUnit: 'Selecione a unidade',
    Headquarters: 'Matriz',
    SearchCompanies: 'Buscar...',
    NoCompaniesFound: 'Nenhuma filial encontrada',
    ErrorLoadingCompanies: 'Não foi possível carregar as filiais',
    HelpCenter: 'Central de ajuda',
    Support: 'Chamados',
    Assistant: 'Assistente de IA',
    AssistantComingSoon: 'Assistente de IA, em breve',
    SoonBadge: 'Em breve',
    SwitchToDarkMode: 'Ativar modo escuro',
    SwitchToLightMode: 'Ativar modo claro'
  },
  'en-US': {
    SwitchToDarkMode: 'Enable dark mode',
    SwitchToLightMode: 'Enable light mode',
    Headquarters: 'Headquarters',
    SearchCompanies: 'Search...',
    NoCompaniesFound: 'No branches found',
    ErrorLoadingCompanies: 'Unable to load branches',
    SystemInfo: 'Information'
  }
}

export const useTranslation = () => useI18n({ messages: translations })
